module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_c('modal', {
    attrs: {
      "size": "medium"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_vm._v("\n                Informations sur les équipes :\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("Pour qu'une équipe puisse être séléctionnée dans un rapport de match, elle doit : ")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("- appartenir au joueur connecté (sauf pour les admins)")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("- avoir été publié (ne pas être en mode brouillon)")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("- avoir fait les montées de niveau")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("- avoir validé les achats ")]), _vm._v(" "), _c('div', {
    staticClass: "row columns small-font"
  }, [_vm._v("- ne pas être dans un autre rapport de match en cours de saisie")])])]), _vm._v(" "), (_vm.teamList) ? _c('div', {
    staticClass: "roster",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.teamList.length > 0) ? _c('table', {
    staticClass: "row column ranking"
  }, [_c('thead', [_c('tr', {}, [_c('th', {
    attrs: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "team_name_header",
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "last_stat",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("en etat de jouer ?")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60%"
    }
  }, [_vm._v("Raison")])])]), _vm._v(" "), _vm._l((_vm.teamList), function(team) {
    return _c('tr', {
      on: {
        "click": function($event) {
          return _vm.teamClicked(_vm.ranking_line.team.id)
        }
      }
    }, [_c('td', [_c('img', {
      staticClass: "small-icon",
      attrs: {
        "src": _vm.getRosterIcon(team.ref_roster),
        "alt": "team"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(team.name))]), _vm._v(" "), (_vm.getStatus(team)) ? _c('td', {
      staticClass: "error"
    }, [_vm._v("non")]) : _c('td', {
      staticClass: "valid"
    }, [_vm._v("oui")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getStatus(team)))])])
  })], 2) : _c('div', [_vm._v("\n                vous n'avez pas d'équipe dans cette ligue, commencez par en créer une\n        ")])]) : _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("\n            pas d'équipe dans cette ligue\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "large-4 light-grey-button",
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("aaaaah okokokok")])]), _vm._v(" "), _c('br')])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d88671b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/team-status-modal.vue
// module id = 803
// module chunks = 0